import  * as InstrumentUptimeConstants from './InstrumentUptimeConstants';
import AppService from 'Global/AppService';

export const addDeviceToInstrumentUptimeReducerState = (instanceId) => {
	return {
		type: InstrumentUptimeConstants.INSTRUMENT_UPTIME_DEVICE_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceFromInstrumentUptimeReducerState = (instanceId) => {
	return {
		type: InstrumentUptimeConstants.INSTRUMENT_UPTIME_DEVICE_STATE_REMOVE,
		payload: instanceId
	}
};

export const fetInstrumentRunningStatus = (url, payload, instanceId) => {
    return (dispatch) => {
        dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_REQUEST, payload: { instanceId, newState: payload } });
        function callback(success, err) {
            if (success.result) {
                dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_SUCCESS, payload: { instanceId, newState: success.result } });
            } else {
                dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_RUNNING_STATUS_FAILURE, payload: { instanceId, newState: err.responseJSON } });
            }
        }
        AppService.postData(payload, url, callback);
    }
}

export const fetInstrumentRunningStatusGraph = (url, payload, instanceId) => {
    return (dispatch) => {
        dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_REQUEST, payload: { instanceId, newState: payload } });
        function callback(success, err) {
            if (success.result) {
                dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_SUCCESS, payload: { instanceId, newState: success.result } });
            } else {
                dispatch({ type: InstrumentUptimeConstants.INSTRUMENT_GRAPH_POINTS_FAILURE, payload: { instanceId, newState: err.responseJSON } });
            }
        }
        AppService.postData(payload, url, callback);
    }
}